import {STAT_BACKGROUND_MODES} from '../constants/visuals';

/**
 * ШЕВРОНЫ ОТРЯДОВ: плашка размера под отрядом с крыльями для снабжения и хода и
 * нижняя часть с изменением размера. Темная плашка в золотой оправе с заостренными
 * концами, в гамме медальонов.
 *
 * Рисует HexGridRenderer, текстуры считает код (utils/effects/unitBadgeTextures).
 * Размеры — в единицах поля. Границы крыльев те же, что у прежних картинок: на них
 * стоят иконки снабжения, хода и результаты боя.
 */

export const UNIT_BADGE = {
  // Точек картинки на единицу поля: спрайт масштабируется обратно
  pixelsPerUnit: 4,
  // Запас картинки вокруг плашки под тень
  marginUnits: 3,
  halfHeight: 9.5,
  panelHalfWidth: 12.8,
  // Конец плашки: длина острия у крыла и у конца без крыла
  wingTip: 5.2,
  plainTip: 3,
  rimWidth: 1.15,
  dividerHalfWidth: 0.4,
  shadowWidth: 2.4,
  colors: {
    rimLight: [255, 240, 170],
    rim: [255, 190, 40],
    rimDark: [176, 104, 12],
    panelTop: [30, 21, 14],
    panelBottom: [10, 7, 5],
    wingTop: [66, 52, 38],
    wingBottom: [40, 30, 21],
    divider: [214, 150, 36],
    shadow: [18, 9, 2],
  },
};

const PLAIN_END = 15.2;
const WING_SHORT = 38.2;
const WING_MIDDLE = 45.25;
const WING_LONG = 52.85;

/**
 * Границы плашки от центра ячейки по режимам: left и right — докуда она идет, а
 * leftWing и rightWing — есть ли крыло с этой стороны
 */
export const UNIT_BADGE_SHAPES = {
  [STAT_BACKGROUND_MODES.NONE]: {left: PLAIN_END, right: PLAIN_END},
  [STAT_BACKGROUND_MODES.LEFT]: {left: WING_MIDDLE, right: PLAIN_END, leftWing: true},
  [STAT_BACKGROUND_MODES.LEFT_SHORT]: {left: WING_SHORT, right: PLAIN_END, leftWing: true},
  [STAT_BACKGROUND_MODES.RIGHT]: {left: PLAIN_END, right: WING_MIDDLE, rightWing: true},
  [STAT_BACKGROUND_MODES.RIGHT_SHORT]: {left: PLAIN_END, right: WING_SHORT, rightWing: true},
  [STAT_BACKGROUND_MODES.RIGHT_LONG]: {left: PLAIN_END, right: WING_LONG, rightWing: true},
  [STAT_BACKGROUND_MODES.BOTH]: {left: WING_SHORT, right: WING_MIDDLE, leftWing: true, rightWing: true},
  [STAT_BACKGROUND_MODES.BOTH_SHORT]: {left: WING_SHORT, right: WING_SHORT, leftWing: true, rightWing: true},
  [STAT_BACKGROUND_MODES.BOTH_LONG]: {left: WING_SHORT, right: WING_LONG, leftWing: true, rightWing: true},
};

export const UNIT_SIZE_DELTA_KINDS = {
  // Докупка за снабжение, за монеты, потери и гибель всего отряда
  INCREASE: 'increase',
  INCREASE_COINS: 'increase_coins',
  DECREASE: 'decrease',
  KILLED: 'killed',
};

/**
 * Плашка с изменением размера: продолжает плашку размера вниз. Верх темный — на нем
 * размер отряда, а низ цветной — на нем изменение
 */
export const UNIT_SIZE_DELTA_BADGE = {
  halfWidth: 13.4,
  halfHeight: 18.4,
  cornerRadius: 3.6,
  rimWidth: 1.15,
  // Текстура стоит на 9 единиц ниже плашки размера: там ее верх совпадает с верхом плашки
  shiftY: 9,
  styles: {
    [UNIT_SIZE_DELTA_KINDS.INCREASE]: {
      bottomTop: [236, 160, 104], bottomBottom: [192, 112, 64], rimLight: [255, 240, 170], rim: [255, 190, 40], rimDark: [176, 104, 12],
    },
    [UNIT_SIZE_DELTA_KINDS.INCREASE_COINS]: {
      bottomTop: [255, 224, 96], bottomBottom: [255, 176, 20], rimLight: [255, 240, 170], rim: [255, 190, 40], rimDark: [176, 104, 12],
    },
    [UNIT_SIZE_DELTA_KINDS.DECREASE]: {
      bottomTop: [226, 34, 28], bottomBottom: [150, 10, 10], rimLight: [255, 170, 150], rim: [226, 42, 34], rimDark: [116, 12, 12],
    },
    // Весь отряд погибнет: красное накрывает и размер, мигая
    [UNIT_SIZE_DELTA_KINDS.KILLED]: {
      isSolid: true, bottomTop: [232, 36, 28], bottomBottom: [160, 8, 8], rimLight: [255, 170, 150], rim: [226, 42, 34], rimDark: [116, 12, 12],
    },
  },
};
